<template>
  <div class="main" :class="{ disabled: isShare }">
    <div class="status-bar"></div>
    <div class="top">
      <img
        src="@/assets/lucky/icon_back.png"
        alt=""
        class="back"
        @click="goBack"
      />
      <div v-if="joinList.length" class="notice">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, i) of joinList" :key="i">
            <span>{{ item }}刚刚参与了抽奖</span>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="rule" @click="$router.push('/lucky/rule')"></div>
      <div class="share" @click="toShare"></div>
    </div>
    <div class="body">
      <div class="nav">
        <div class="ticket" @click="toTicket">
          <img src="@/assets/lucky/tag_ticket.png" alt="" class="tag" />
          <span>我的抽奖券({{ totalTicket }}张）</span>
        </div>
        <div class="record" @click="$router.push('/lucky/record')">
          我的参与记录
        </div>
      </div>
      <div class="block award">
        <div class="title"></div>
        <template v-if="awardList.length">
          <div class="item" v-for="(item, i) of awardList" :key="i">
            <div class="info">
              <img :src="item.image" alt="" class="logo" />
              <div class="content">
                <div class="title">{{ item.name }}</div>
                <div class="progress">
                  <div class="bar">
                    <div
                      class="active"
                      :style="{ width: `${item._rate}%` }"
                    ></div>
                  </div>
                  <span>共需{{ item.total_lottery_ticket_nums }}张</span>
                </div>
                <div class="other">
                  <div class="price">价值:￥{{ item.price }}</div>
                  <div
                    v-if="
                      item._rate >= 100 ||
                        item.member_ticket_count >=
                          item.max_lottery_ticket_nums_can_use
                    "
                    class="btn disabled"
                  >
                    待开奖
                  </div>
                  <div
                    v-else-if="item.member_ticket_count"
                    class="btn"
                    :class="{ disabled: !item._canuse }"
                    @click="toJoin(item)"
                  >
                    已参与{{ item.member_ticket_count }}张
                  </div>
                  <div
                    v-else
                    class="btn"
                    :class="{ disabled: !item._canuse }"
                    @click="toJoin(item)"
                  >
                    参与抽奖
                  </div>
                </div>
              </div>
            </div>
            <div class="desc">
              <div>
                <img src="@/assets/lucky/icon_user.png" alt="" class="icon" />
                <span>{{ item.activity_member_count }}人参与</span>
              </div>
              <div>
                <img src="@/assets/lucky/icon_ticket.png" alt="" class="icon" />
                <span>已参与{{ item.total_lottery_bets_nums }}张券</span>
              </div>
              <div>
                <img src="@/assets/lucky/icon_date.png" alt="" class="icon" />
                <span v-if="item._day">剩余{{ item._day }}天</span>
                <span v-if="item._second">剩余{{ item._text }}</span>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="empty">
          <img src="@/assets/lucky/empty.png" alt="" class="icon" />
          <span class="desc">暂无奖品，敬请期待</span>
        </div>
      </div>
      <div class="block preview">
        <div class="title"></div>
        <template v-if="previewList.length">
          <div class="item" v-for="(item, i) of previewList" :key="i">
            <img :src="item.image" alt="" class="logo" />
            <div class="content">
              <div class="title">{{ item.name }}</div>
              <div class="desc">
                <span>抽奖时间 {{ item._date }}</span>
                <span>热度 {{ item.count_reminder }}</span>
              </div>
              <div v-if="item.is_reminder" class="btn disabled">预约成功</div>
              <div v-else class="btn" @click="toReserve(item)">点击预约</div>
            </div>
          </div>
        </template>
        <div v-else class="empty">
          <img src="@/assets/lucky/empty.png" alt="" class="icon" />
          <span class="desc">敬请期待</span>
        </div>
      </div>
      <div class="block task">
        <div class="title"></div>
        <div class="item" v-for="(task, i) of tasks" :key="i">
          <img :src="task.icon" alt="" class="icon" />
          <div class="info">
            <span class="title">{{ task.title }}</span>
            <span class="desc">{{ task.desc }}</span>
          </div>
          <div class="btn" @click="task.callback()">{{ task.btnText }}</div>
        </div>
      </div>
      <div class="block dog">
        <div class="title"></div>
        <van-list
          v-if="dogList.length"
          class="list"
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="发生异常，请刷新！"
          finished-text="没有更多了"
          @load="getGog"
        >
          <div class="item" v-for="(item, i) of dogList" :key="i">
            <div class="t">
              <img :src="item.head_pic" alt="" class="head" />
              <span class="name">{{ item._mobile }}</span>
              <span v-if="item.lucky_draw" class="date">{{
                item.lucky_draw.lottery_time
              }}</span>
            </div>
            <div v-if="item.lucky_draw" class="goods">
              <img :src="item.lucky_draw.image" alt="" class="icon" />
              <div class="info">
                <div class="title">{{ item.lucky_draw.name }}</div>
                <span class="price">￥{{ item.lucky_draw.price }}</span>
              </div>
            </div>
          </div>
        </van-list>
        <div v-else class="empty">
          <img src="@/assets/lucky/empty.png" alt="" class="icon" />
          <span class="desc">暂无中奖记录</span>
        </div>
      </div>
    </div>

    <Join v-model="joinVisible" :data="active" @reload="joinCallback" />
    <Ticket v-model="ticketVisible" :total="totalTicket" />
    <Win v-model="winVisible" />
    <Shade :visible="isShare" />
  </div>
</template>

<script>
import mixin from "./mixin";
import Join from "./join.vue";
import Ticket from "./ticket.vue";
import Win from "./win.vue";
import Shade from "./shade.vue";
import { getTimestamp, getCountDown, getFmtDate, encodeMobile } from "./utils";

export default {
  components: {
    Join,
    Ticket,
    Win,
    Shade,
  },
  mixins: [mixin],
  data() {
    return {
      memberId: undefined,
      isShare: false,
      joinList: [],
      totalTicket: 0,
      awardList: [], // 全部奖池
      tempList: [],
      previewList: [], // 预告列表
      active: null,
      dogList: [], // 中奖公示
      loading: false,
      finished: false,
      error: false,
      page: 0,
      tasks: [
        {
          icon: require("@/assets/lucky/icon_buy.png"),
          title: "去三年购专区下单得抽奖券",
          desc: "每满100元，得一张抽奖券",
          btnText: "去下单",
          callback: () => this.$router.push("/thirdYear"),
        },
        // {
        //   icon: require("@/assets/lucky/icon_vip.png"),
        //   title: "开通VIP会员，得抽奖券",
        //   desc: "一次最高可得200张",
        //   btnText: "去开通",
        //   callback: () => this.$router.push("/member/privilege"),
        // },
      ],
      S: null, // 分享配置
      joinVisible: false,
      ticketVisible: false,
      winVisible: false,
    };
  },
  async created() {
    const { share } = this.$route.query;
    this.isShare = !!share || false;
    try {
      await this.getMember();
      await this.getTicket();
      await this.getWin();
    } catch (error) {}
    this.getAward();
    this.getPreview();
    this.getJoin();
    this.getGog();
    this.getShareConfig();
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    getMember() {
      return this.$api.get("/member/member/user/detail").then((res) => {
        this.memberId = res.id;
        console.log("会员ID", this.memberId);
      });
    },
    getShareConfig() {
      return this.$api
        .post("activity/index/lucky/get-lucky-config", {
          name: "share_config",
        })
        .then((res) => {
          console.log("分享配置", res);
          this.S = res;
        });
    },
    getJoin() {
      this.$api.post("activity/index/lucky/draw-roll").then((res) => {
        this.joinList = Array.from(new Set(res.map((_) => encodeMobile(_))));
        console.log("参与人员", this.joinList);
      });
    },
    getAward() {
      return this.$api
        .post("activity/index/lucky/list", { member_id: this.memberId })
        .then((res) => {
          this.awardList = res.list.map((_) => {
            let _second = getTimestamp(_.lottery_time) - getTimestamp();
            _second = Math.floor(_second / 1000);
            if (_second > 24 * 60 * 60) {
              _._day = Math.floor(_second / (24 * 60 * 60));
            } else {
              _._second = _second;
              _._text = getCountDown(_second, "h:m:s");
              this.tempList.push(_);
            }
            _._rate =
              (_.total_lottery_bets_nums / _.total_lottery_ticket_nums) * 100;
            _._canuse = Math.min(
              Math.min(
                _.max_lottery_ticket_nums_can_use - _.member_ticket_count,
                _.total_lottery_ticket_nums - _.total_lottery_bets_nums
              ),
              this.totalTicket
            );

            if (this.tempList.length) {
              this.startCountDown();
            }
            return _;
          });
          console.log("全部奖池", this.awardList);
        });
    },
    getPreview() {
      return this.$api
        .post("activity/index/lucky/prize-preview/list", {
          member_id: this.memberId,
        })
        .then((res) => {
          this.previewList = res.list.map((_) => {
            _._date = getFmtDate(_.lottery_time, "m-d H:i");
            return _;
          });
          console.log("奖品预告", this.previewList);
        });
    },
    getGog() {
      if (this.finished) {
        return;
      }
      if (!this.refreshing) {
        this.loading = true;
      }
      this.$api
        .post("activity/index/lucky/lucky-gay", {
          page: ++this.page,
          size: 10,
        })
        .then((res) => {
          res.list.forEach((_) => {
            _._mobile = encodeMobile(_.mobile);
          });
          if (this.page == 1) {
            this.dogList = res.list;
          } else {
            this.dogList = this.dogList.concat(res.list);
          }
          this.finished = res.current_page >= res.last_page;
          console.log("中奖公示", this.dogList);
        })
        .catch((e) => (this.error = true))
        .finally(() => (this.loading = false));
    },
    getTicket() {
      return this.$api
        .post("activity/member/lucky/my-ticket-num")
        .then((res) => {
          console.log("抽奖券", res);
          this.totalTicket = res.num || 0;
        });
    },
    getWin() {
      return this.$api.post("activity/member/lucky/has-luck").then((res) => {
        if (res.has_luck) {
          this.winVisible = true;
        }
      });
    },
    toJoin(e) {
      console.log("参与抽奖", e);
      this.active = e;
      this.joinVisible = true;
    },
    toReserve(e) {
      console.log("预约", e);
      this.$api
        .post("activity/member/lucky/create-lucky-reminder", {
          activity_id: e.main_id,
        })
        .then(() => {
          this.$toast("预约成功");
          e.is_reminder = true;
        });
    },
    toTicket() {
      this.ticketVisible = true;
    },
    async toShare() {
      if (!this.S) {
        await this.getShareConfig();
      }
      let paramAndroid = [
        this.S.title,
        this.S.subtitle,
        `${process.env.VUE_APP_BASE_URL}/lucky?share=1`,
        this.S.icon,
      ];
      let paramIOS = [
        this.S.subtitle,
        this.S.title,
        `${process.env.VUE_APP_BASE_URL}/lucky?share=1`,
        this.S.icon,
      ];
      this.params(paramIOS, JSON.stringify(paramAndroid), "toShare");
    },
    startCountDown() {
      this._timer && clearInterval(this._timer);
      this._timer = setInterval(() => {
        this.tempList = this.tempList.filter((_) => {
          _._second -= 1;
          if (_._second <= 0) {
            this.awardList = this.awardList.filter((__) => __.id !== _.id);
            return false;
          } else {
            _._text = getCountDown(_._second, "h:m:s");
            return true;
          }
        });
        if (!this.tempList.length) {
          clearInterval(this._timer);
        }
      }, 1000);
    },
    async joinCallback() {
      await this.getTicket();
      this.getAward();
    },
  },
  beforeDestroy() {
    this._timer && clearInterval(this._timer);
  },
};
</script>

<style lang="less" scoped>
.bg-img {
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.main:extend(.bg-img) {
  font-size: 1.4rem;
  background-image: url(~@/assets/lucky/bg_top.png);
  background-size: 100% 43.6rem;
  background-position-y: calc(-3.4rem + var(--status-height));
  background-color: #fc2a58;

  &::-webkit-scrollbar {
    display: none;
  }

  &.disabled {
    pointer-events: none;
  }
}

.status-bar {
  height: var(--status-height);
}

.top {
  position: relative;
  height: 28rem;

  .back {
    width: 2rem;
    height: 2rem;
    position: absolute;
    left: 0.8rem;
    top: 1.4rem;
  }

  .notice {
    position: absolute;
    width: 20rem;
    height: 2.8rem;
    border-radius: 1.4rem;
    padding: 0 2.3rem;
    background: rgba(255, 255, 255, 0.2);
    left: 50%;
    top: 1rem;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    pointer-events: none;

    &-swipe {
      height: 2.8rem;
      line-height: 2.8rem;

      .van-swipe-item {
        text-align: center;
      }
    }
  }

  .rule,
  .share {
    &:extend(.bg-img);
    width: 2.1rem;
    height: 4.9rem;
    position: absolute;
    right: 0;
  }

  .rule {
    background-image: url(~@/assets/lucky/rule.png);
    top: 2.9rem;
  }

  .share {
    background-image: url(~@/assets/lucky/share.png);
    top: 8.5rem;
  }
}

.body {
  padding: 2.4rem 1.2rem 1.2rem;

  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .ticket,
    .record {
      &:extend(.bg-img);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.7rem;
      color: #f9305b;
      font-weight: 700;
    }

    .ticket {
      box-sizing: border-box;
      width: 19.6rem;
      height: 5.3rem;
      background-image: url(~@/assets/lucky/bg_ticket.png);
      position: relative;
      padding-left: 4.8rem;

      .tag {
        position: absolute;
        width: 5.1rem;
        height: 4.1rem;
        left: -0.7rem;
        top: -0.8rem;
      }
    }

    .record {
      width: 14.4rem;
      height: 5.3rem;
      background-image: url(~@/assets/lucky/bg_record.png);
    }
  }

  .block {
    margin-top: 1.2rem;
    padding: 0 1rem 1rem;
    background: #fef9f3;
    border-radius: 1.2rem;
    border: 0.1rem solid #ffd9b7;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & > .title:extend(.bg-img) {
      align-self: center;
      height: 3.5rem;
    }

    .item {
      margin-top: 1.2rem;
    }
  }

  .award {
    & > .title {
      background-image: url(~@/assets/lucky/award_title.png);
      width: 17.9rem;
    }

    .item {
      background: #fffdfb;
      border-radius: 0.4rem;
      border: 0.1rem solid #f9edef;

      .info {
        flex: 1;
        padding: 1rem;
        display: flex;
        align-items: stretch;

        .logo {
          flex: 0 0 8rem;
          height: 8rem;
          margin-right: 1rem;
          border-radius: 0.4rem;
        }

        .content {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          justify-content: space-between;

          .title {
            font-size: 1.5rem;
            font-weight: 700;
            line-height: 2rem;
            color: #4a1500;
            max-height: 4rem;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .progress {
            margin-top: 0.6rem;
            display: flex;
            align-items: center;
            font-size: 1.1rem;
            color: #643d2d;

            .bar {
              width: 8rem;
              height: 0.6rem;
              background: #fff1e0;
              border-radius: 0.7rem;
              position: relative;
              margin-right: 1rem;

              .active {
                position: absolute;
                height: 0.6rem;
                background: #f9305b;
                border-radius: 0.7rem;
              }
            }
          }

          .other {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .price {
              font-size: 1.2rem;
              font-weight: 700;
              color: #885a47;
            }

            .btn:extend(.bg-img) {
              width: 7.4rem;
              height: 2.6rem;
              display: flex;
              justify-content: center;
              align-items: center;
              background-image: url(~@/assets/lucky/bg_btn.png);
              font-size: 1.2rem;
              color: #fff;
              font-weight: 700;

              &.disabled {
                opacity: 0.5;
                pointer-events: none;
              }
            }
          }
        }
      }

      .desc {
        border-top: 0.1rem solid #f9f4f5;
        padding: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.2rem;
        color: #885a47;

        & > div {
          display: flex;
          align-items: center;
        }

        .icon {
          margin-right: 0.5rem;
        }

        div:nth-of-type(1) .icon {
          width: 1.1rem;
          height: 1.1rem;
        }
        div:nth-of-type(2) .icon {
          width: 1.2rem;
          height: 1.15rem;
        }
        div:nth-of-type(3) .icon {
          width: 1.2rem;
          height: 1.2rem;
        }
      }
    }
  }

  .preview {
    & > .title {
      background-image: url(~@/assets/lucky/preview_title.png);
      width: 17.9rem;
    }

    .item {
      flex: 1;
      padding: 1.1rem;
      display: flex;
      align-items: stretch;
      background: #fffdfb;
      border-radius: 0.4rem;
      border: 0.1rem solid #f9edef;

      .logo {
        flex: 0 0 8rem;
        height: 8rem;
        margin-right: 1rem;
        border-radius: 0.4rem;
      }

      .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: space-between;

        .title {
          font-size: 1.5rem;
          font-weight: 700;
          line-height: 2rem;
          color: #4a1500;
          max-height: 4rem;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .desc {
          margin-top: 0.6rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.2rem;
          color: #885a47;
        }

        .btn:extend(.bg-img) {
          margin-top: 0.8rem;
          width: 7.4rem;
          height: 2.6rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: url(~@/assets/lucky/bg_btn.png);
          font-size: 1.2rem;
          color: #fff;
          font-weight: 700;

          &.disabled {
            opacity: 0.5;
          }
        }
      }
    }
  }

  .task {
    & > .title {
      background-image: url(~@/assets/lucky/task_title.png);
      width: 24.7rem;
    }

    .item {
      padding: 1.6rem 1.1rem;
      background: #fffdfb;
      border-radius: 0.4rem;
      border: 0.1rem solid #f9edef;
      display: flex;
      align-items: center;

      .icon {
        flex: 0 0 3.6rem;
        height: 3.6rem;
        margin-right: 0.8rem;
      }

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;

        .title {
          font-size: 1.5rem;
          color: #4a1500;
          font-weight: 700;
        }

        .desc {
          font-size: 1.1rem;
          color: #885a47;
          margin-top: 0.2rem;
        }
      }

      .btn {
        flex: 0 0 6.2rem;
        height: 2.6rem;
        background: linear-gradient(
          180deg,
          #ffabc8 0%,
          #ff4a82 15%,
          #fb2553 100%
        );
        border-radius: 1.3rem;
        border: 0.1rem solid #ffd9b7;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
        color: #fff;
        font-weight: 700;
      }
    }
  }

  .dog {
    & > .title {
      background-image: url(~@/assets/lucky/dog_title.png);
      width: 19.9rem;
    }

    .item {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      background: #fffdfb;
      border: 0.1rem solid #f9edef;
      border-radius: 0.4rem;
      padding: 1.1rem;

      .t {
        display: flex;
        align-items: center;

        .head {
          flex: 0 0 2.8rem;
          height: 2.8rem;
          border-radius: 100%;
          margin-right: 0.7rem;
        }

        .name {
          align-self: center;
          flex: 1;
          color: #4a1500;
          font-weight: 700;
          margin-right: 0.7rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .date {
          font-size: 1.2rem;
          color: #885a47;
        }
      }

      .goods {
        margin-top: 0.8rem;
        display: flex;
        align-items: stretch;
        overflow: hidden;

        .icon {
          flex: 0 0 4.8rem;
          height: 4.8rem;
          border-radius: 0.4rem;
          margin-right: 0.8rem;
        }

        .info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          overflow: hidden;

          .title {
            color: #885a47;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .price {
            font-size: 1.2rem;
            color: #f9305b;
            font-weight: 700;
          }
        }
      }
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 7.5rem 0;

    .icon {
      width: 4.5rem;
      height: 4.1rem;
      margin-bottom: 0.6rem;
    }

    .desc {
      color: #885a47;
    }
  }
}
</style>
